import React, {Component} from "react"
import {isEmpty} from "lodash"

import {H3} from "@irati/ui/src/Typography"
import {Team} from "@irati/admin/types"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"

import Pill from "@irati/ui/src/Pill"

import {StyledCard} from "../../../../containers/Reporting/styled"
import {ReactTable} from "../../../Table"
import {HeaderWrapper, PillWrapper} from "../../styled/styled"
import {EmptyRegions, EmptyTeams} from "../../EmptyData"
import columns from "./columns/index"

const PAGE_SIZE = 5

interface Props extends InjectIntl {
  teams: Team[]
  isRegion?: boolean
  onPageChange?: (nextPage: number) => void
}
interface State {
  page: number
  limit: number
}

class PlatformActivityByTeam extends Component<Props, State> {
  state = {
    page: 0,
    limit: PAGE_SIZE
  }

  handlePageChange = (nextPage: number) => {
    this.setState({page: nextPage})
  }

  render() {
    const {teams, isRegion, formatMessage} = this.props
    const count = isEmpty(teams) ? 0 : teams.length
    const {page, limit} = this.state
    const pages = Math.ceil(count / limit)

    const title = isRegion ? "admin.reporting.activationRate.countries" : "admin.reporting.activationRate.teams"
    const pillText = isRegion ? "admin.reporting.countryCount" : "admin.reporting.teamCount"
    const EmptyComponent = isRegion ? EmptyRegions : EmptyTeams
    const id = isRegion ? "adminSection_reporting_activationRateByCountriesSection" : "adminSection_reporting_activationRateByTeamsSection"
    return (
      <StyledCard id={id}>
        <HeaderWrapper>
          <H3>
            <FormattedMessage id={title} />
          </H3>
          <PillWrapper>
            <Pill text={<FormattedMessage id={pillText} values={{count}} />} backgroundColor="#FBB03C" isWhiteText />
          </PillWrapper>
        </HeaderWrapper>
        {teams?.length ? (
          <ReactTable
            manual={false}
            getPaginationProps={(allProps: any) => ({
              ...allProps,
              shouldScrollOnUpdate: false
            })}
            page={page}
            pages={pages}
            onPageChange={this.handlePageChange}
            showPagination={pages > 1}
            data={teams}
            defaultPageSize={PAGE_SIZE}
            columns={columns(formatMessage, isRegion)}
          />
        ) : (
          <EmptyComponent />
        )}
      </StyledCard>
    )
  }
}

export default injectIntl(PlatformActivityByTeam)
